// extracted by mini-css-extract-plugin
export default {"container":"DefaultLayout_container__esPmt styles_layoutContainer__ZDbSY"};